"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Radio.css");

var _styles = {
  "radio-button": "Radio__radio-button___2DI2C",
  "radio": "Radio__radio___MC1Z-",
  "label": "Radio__label___l5ygl",
  "text-16": "Radio__text-16___MHNa9",
  "text-14": "Radio__text-14___ZzLmq",
  "regular": "Radio__regular___YGFsH",
  "medium": "Radio__medium___W9bmJ",
  "radio-container": "Radio__radio-container___3RkFF",
  "small": "Radio__small___13vFd"
};

const styles = _bind.default.bind(_styles);

const Radio = (0, _mobxReact.observer)(({
  className,
  inputClassName,
  name,
  small,
  options,
  value,
  gap,
  onChange,
  onClick,
  dataTestId,
  variant = 'medium',
  size = 16,
  ...props
}) => {
  const container_classnames = (0, _bind.default)(styles('radio-container', {
    small
  }), className);
  const input_classnames = (0, _bind.default)(styles('radio-button'), inputClassName);
  const composed_styles = {
    gap: `${gap}px`
  };
  return _react.default.createElement("div", {
    className: container_classnames,
    style: composed_styles,
    "data-testid": dataTestId,
    ...props
  }, options === null || options === void 0 ? void 0 : options.map((item, i) => _react.default.createElement("div", {
    className: input_classnames,
    key: i
  }, _react.default.createElement("label", null, _react.default.createElement(_.Text, {
    tag: 'span',
    className: styles('label', variant, `text-${size}`)
  }, item.name), _react.default.createElement("input", {
    "data-testid": dataTestId && `${dataTestId}-${item.value}`,
    id: item.name,
    type: 'radio',
    name: name,
    value: item.value,
    checked: item.value === value,
    onChange: e => onChange && onChange(e),
    onClick: e => {
      e.persist();
      onClick && onClick(e);
    },
    disabled: item.disabled
  }), _react.default.createElement("span", {
    className: (0, _bind.default)(styles('radio'))
  })))));
});
var _default = Radio;
exports.default = _default;